exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ed-field-checklist[data-v-5e3b9785] {\n  margin: 4px 0 12px;\n  padding: 14px 16px;\n  border-radius: 8px;\n  background: var(--ced-bg, #f6f7f9);\n}\n", ""]);

// exports
